module.exports = __webpack_public_path__ + "static/img/icon01.b87b2f01.png";